import { Grid } from '@material-ui/core';
import {
  EntityAboutCard,
  EntityHasComponentsCard,
  EntityHasResourcesCard,
  EntityLabelsCard,
  EntityLayout,
  EntityLinksCard,
} from '@backstage/plugin-catalog';
import {
  EntityHasApisCard,
} from '@backstage/plugin-api-docs';
import {
  Direction,
  EntityCatalogGraphCard,
} from '@backstage/plugin-catalog-graph';
import {
  RELATION_API_CONSUMED_BY,
  RELATION_API_PROVIDED_BY,
  RELATION_CONSUMES_API,
  RELATION_DEPENDENCY_OF,
  RELATION_DEPENDS_ON,
  RELATION_HAS_PART,
  RELATION_PART_OF,
  RELATION_PROVIDES_API,
} from '@backstage/catalog-model';
import {
  EntitySoundcheckCard,
  EntitySoundcheckContent,
} from '@spotify/backstage-plugin-soundcheck';
import { DefaultRenderNode } from '../nodes/DefaultRenderNode';
import { entityWarningContent } from './EntityWarningContent';

export const systemPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3} alignItems="stretch">
        {entityWarningContent}
        <Grid item lg={6} md={12} xs={12}>
          <EntityAboutCard variant="gridItem" />
        </Grid>
        <Grid item lg={6} md={12} xs={12}>
          <EntityCatalogGraphCard
            variant="gridItem"
            height={400}
            renderNode={DefaultRenderNode}
          />
        </Grid>

        <Grid item lg={6} md={12}>
          <Grid container direction="column" spacing={3}>
            <Grid item>
              <EntityLabelsCard variant="flex" />
            </Grid>
            <Grid item>
              <EntityLinksCard />
            </Grid>
          </Grid>
        </Grid>

        <Grid item lg={6} md={12}>
          <EntitySoundcheckCard data-intercom-target="entity-page-overview-soundcheck" />
        </Grid>
        <Grid item md={12}>
          <EntityHasApisCard variant="gridItem" />
        </Grid>

        <Grid item xl={6} md={12}>
          <EntityHasComponentsCard variant="gridItem" />
        </Grid>
        <Grid item xl={6} md={12}>
          <EntityHasResourcesCard variant="gridItem" />
        </Grid>
      </Grid>
    </EntityLayout.Route>
    <EntityLayout.Route path="/diagram" title="Diagram">
      <EntityCatalogGraphCard
        renderNode={DefaultRenderNode}
        variant="gridItem"
        direction={Direction.TOP_BOTTOM}
        title="System Diagram"
        height={700}
        relations={[
          RELATION_PART_OF,
          RELATION_HAS_PART,
          RELATION_API_CONSUMED_BY,
          RELATION_API_PROVIDED_BY,
          RELATION_CONSUMES_API,
          RELATION_PROVIDES_API,
          RELATION_DEPENDENCY_OF,
          RELATION_DEPENDS_ON,
        ]}
        unidirectional={false}
      />
    </EntityLayout.Route>
    <EntityLayout.Route path="/soundcheck" title="Soundcheck">
      <EntitySoundcheckContent />
    </EntityLayout.Route>
  </EntityLayout>
);
